<div class="image-dialog-container">
    <div class="image-dialog-title-container">
        <div class="image-dialog-title-text">
            {{ data.displayText }}
        </div>
        <mat-icon fontIcon="close" [mat-dialog-close]="true" class="image-dialog-title-icon">
        </mat-icon>
    </div>
    <div class="image-dialog-slider">
        <app-image-slider [indicatorsVisible]="true" [animationSpeed]="0" [slides]="data.images" [autoPlay]="false"
            [autoPlaySpeed]="0"></app-image-slider>
    </div>
</div>